import script from "./purchaselist.vue?vue&type=script&setup=true&lang=js"
export * from "./purchaselist.vue?vue&type=script&setup=true&lang=js"

import "./purchaselist.vue?vue&type=style&index=0&id=74cc564d&lang=css"

const __exports__ = script;

export default __exports__